import { Button, Flex } from '@chakra-ui/react';
import { ArrowUpRightIcon } from 'lucide-react';
import { FC } from 'react';

/**
 * Document-level action buttons shown above the suggestions for the selected
 * document. Visual-only placeholders for now — the resubmit / fix-in-platform
 * flows are wired up in a later phase.
 */
export const DocumentActionButtons: FC = () => (
  <Flex gap={2} w="full">
    <Button
      _hover={{ bg: 'whiteAlpha.200' }}
      bg="whiteAlpha.100"
      borderColor="whiteAlpha.200"
      borderRadius="8px"
      borderWidth={1}
      color="white"
      flex={1}
      fontSize="sm"
      fontWeight="medium"
      size="sm"
    >
      Ignore and resubmit
    </Button>
    <Button
      _hover={{ bg: 'cyan.400' }}
      bg="cyan.500"
      borderRadius="8px"
      color="indigo.900"
      flex={1}
      fontSize="sm"
      fontWeight="medium"
      rightIcon={<ArrowUpRightIcon size={14} />}
      size="sm"
    >
      Fix in SkySlope
    </Button>
  </Flex>
);
